import { useState, useEffect } from "react";
import { baseurl_viewdata, baseurl_viewdesign } from "../conf/settings";
import { grid_settings } from "../conf/settingsView";
import ViewIconCellRenderer from "../components/ViewIconCellRenderer";
import ViewDateCellRenderer from "../components/ViewDateCellRenderer";
import axios from "axios";

const useViewSettings = (server, replicaid, viewname, reload) => {
  const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);
  const [error, setError] = useState(null);
  const gridSettings = grid_settings;

  useEffect(() => {
    (async (server, replicaid, viewname) => {
      // get col defs url from row data url
      const urlData = `${server}/${baseurl_viewdata}/${replicaid}/${viewname}`;
      const urlDsgn = `${server}/${baseurl_viewdesign}/${replicaid}/${viewname}`;

      // get view design and view data
      const viewPromises = [];
      viewPromises.push(axios.get(urlData));
      viewPromises.push(axios.get(urlDsgn));

      try {
        const viewRes = await axios.all(viewPromises);

        // Success
        const resData = viewRes[0];
        const resDsgn = viewRes[1];

        let viewDesign = [];
        if (resDsgn.data.columns && Array.isArray(resDsgn.data.columns)) {
          viewDesign = resDsgn.data.columns;
        }

        let viewData = [];
        if (resData.data.data && Array.isArray(resData.data.data)) {
          viewData = resData.data.data;
        }

        // get category fields
        const rowGroupFields = viewDesign.filter((e) => e.rowGroup === true).map((e) => e.field);
        const rowMultiFields = viewDesign.filter((e) => e.ismulticategory === true).map((e) => e.field);

        // get max category depth per field
        const maxDepth = Array.apply(null, { length: rowGroupFields.length }).map((e) => 1);
        for (let d of viewData) {
          for (let i = 0; i < rowGroupFields.length; i++) {
            const rowGroupData = d[rowGroupFields[i]];
            let depth = Array.isArray(rowGroupData) ? rowGroupData.length : 1;
            maxDepth[i] = depth > maxDepth[i] ? depth : maxDepth[i];
          }
        }

        // split category fields according to depth
        let rows = viewData.map((entry) => {
          let jsonData = {};
          Object.keys(entry).forEach((key) => {
            const idxg = rowGroupFields.findIndex((e) => e === key);
            const idxm = rowMultiFields.findIndex((e) => e === key);
            if (idxm > -1) {
              // split category fields according to depth
              if (idxg > -1) {
                const rowdata = entry[key];
                if (Array.isArray(rowdata)) {
                  for (var r = 0; r < maxDepth[idxg]; r++) {
                    if (r === 0) {
                      jsonData[key] = rowdata[r];
                    } else if (r < rowdata.length) {
                      jsonData[key + r] = rowdata[r];
                    }
                  }
                }
              }
            } else if (idxg > -1) {
              // split data for
              const rowdata = entry[key];
              if (Array.isArray(rowdata)) {
                jsonData[key] = rowdata;
              }
            } else {
              jsonData[key] = entry[key];
            }
          });
          return jsonData;
        });

        setRowData(rows);

        var cols = [];
        for (let dd of viewDesign) {
          const indxg = rowGroupFields.findIndex((e) => e === dd.field);
          const indxm = rowMultiFields.findIndex((e) => e === dd.field);
          const colsToAdd = indxg > -1 ? maxDepth[indxg] : 1;
          const multivcol = indxm > -1 ? true : false;

          var jsonData = {};
          jsonData["enableRowGroup"] = true;

          var keys = Object.keys(dd);
          for (var key of keys) {
            if (key === "icon" && dd[key]) {
              jsonData["cellRendererFramework"] = ViewIconCellRenderer;
            } else if (key === "datetime" && dd[key]) {
              jsonData["cellRendererFramework"] = ViewDateCellRenderer;
            } else if (key === "showingrid" && dd[key]) {
              jsonData["hide"] = jsonData["hide"] ? jsonData["hide"] : !dd[key];
            } else if (key === "hidden" && dd[key]) {
              jsonData["hide"] = dd[key];
              console.log("dd[key] hidden", dd);
            } else if (key === "isunid" && dd[key] === true) {
              // setUnidField(dd["field"]);
            } else {
              jsonData[key] = dd[key];
            }
          }

          const fldvalue = jsonData["field"];
          for (var c = 0; c < colsToAdd; c++) {
            if (colsToAdd > 1 && multivcol) {
              jsonData["field"] = fldvalue + c;
              jsonData["hide"] = true;
            }
            cols = [...cols, Object.assign({}, jsonData)];
          }
        }

        for (var n = 0; n < cols.length; n++) {
          cols[n]["position"] = n + 1;
        }

        setColDefs(cols);
      } catch (error) {
        if (error.response) {
          setError({ status: error.response.status, data: error.response.data });
        } else if (error.request) {
          setError({ data: error.request });
        } else {
          setError({ data: error.message });
        }
        console.log(error);
      }

      // const responseCD = await axios.get(urlDsgn);
      // if (responseCD.data.columns) {
      //   var cols = responseCD.data.columns.map((entry) => {
      //     var jsonData = {};
      //     jsonData["enableRowGroup"] = true;
      //     Object.keys(entry).forEach(function (key) {
      //       if (key === "icon" && entry[key]) {
      //         jsonData["cellRendererFramework"] = ViewIconCellRenderer;
      //       } else if (key === "datetime" && entry[key]) {
      //         jsonData["cellRendererFramework"] = ViewDateCellRenderer;
      //       } else if (key === "hidden" && entry[key]) {
      //         jsonData["hide"] = true;
      //       } else {
      //         jsonData[key] = entry[key];
      //       }
      //     });
      //     return jsonData;
      //   });

      //   setColDefs([coldef_unid, ...cols]);
      // }

      // const response = await axios.get(urlData);
      // if (response.data.data && Array.isArray(response.data.data)) {
      //   var rows = response.data.data.map((entry) => {
      //     var jsonData = {};
      //     Object.keys(entry).forEach(function (key) {
      //       jsonData[key] = entry[key];
      //     });
      //     return jsonData;
      //   });

      //   setRowData(rows);
      // } else {
      //   setRowData({});
      // }
    })(server, replicaid, viewname);
  }, [server, replicaid, viewname, reload]);

  return [rowData, colDefs, gridSettings, error];
};

export default useViewSettings;
